import React, { useState, createContext, useEffect } from 'react'

export const VariablesContext = createContext({} as any) // eslint-disable-line @typescript-eslint/no-explicit-any

const storageKey = (providerKey: string) =>
  `legal_notices_filters_${providerKey}`

const VariablesContextProvider = ({
  providerKey,
  children,
}: {
  providerKey: string
  children: React.ReactNode
}) => {
  const stored = sessionStorage.getItem(storageKey(providerKey))
  const initial = stored
    ? JSON.parse(stored)
    : {
        pagination: { current: 1, pageSize: 30 },
        filters: {},
        search: { value: null },
      }

  const [variables, setVariables] = useState<any>(initial) // eslint-disable-line @typescript-eslint/no-explicit-any

  useEffect(() => {
    const s = sessionStorage.getItem(storageKey(providerKey))
    if (s) setVariables(JSON.parse(s))
    else
      setVariables({
        pagination: { current: 1, pageSize: 30 },
        filters: {},
        search: { value: null },
      })
  }, [providerKey])

  const apiParameters = () => ({
    pagination: {
      page: variables.pagination.current,
      pageLength: variables.pagination.pageSize,
    },
    filters: variables.filters
      ? Object.entries(variables.filters)
          .map(([field, values]) => (values ? { field, values } : null))
          .filter(Boolean)
      : null,
    search: variables.search,
  })

  const save = (updated: any) => {
    // eslint-disable-line @typescript-eslint/no-explicit-any
    sessionStorage.setItem(storageKey(providerKey), JSON.stringify(updated))
    setVariables(updated)
  }

  return (
    <VariablesContext.Provider
      value={{ variables, setVariables: save, apiParameters }}
    >
      {children}
    </VariablesContext.Provider>
  )
}

export default VariablesContextProvider
